<!-- 选择照片面板 -->
<template>
    <panel-down :isShowHead="false" :isShowCont="isShowCont" :contStyleType="0" @closePanel="closePanel">
        <div class="pub-chooseimage-wrap">
            <div class="pub-chooseimage-sect">
                <div class="pub-chooseimage-item panel-title">更换头像</div>
                <div class="pub-chooseimage-item" @click="chooseImage(2)">拍照</div>
                <div class="pub-chooseimage-item" @click="chooseImage(1)">从手机相册选择</div>
            </div>
            <div class="pub-chooseimage-sect">
                <div class="pub-chooseimage-item" @click="closePanel">取消</div>
            </div>
        </div>
    </panel-down>
</template>
<script>
export default {
    props: {
        curTarget: { //修改目标
            type: String,
            default: ""
        },
    },
	data () {
		return {
            isShowCont: true,
		}
    },
    mounted(){
    },
	methods: {
        //选择照片来源: 1:album, 2:camera
        chooseImage(sourceType){
            this.$emit("chooseImage",sourceType,this.curTarget);
            this.closePanel();
        },
        //取消
        closePanel() {
            this.isShowCont = false;
            let delayClosePanel = setTimeout(() => {
                this.$emit("closePanel");
            }, 500);
        },
	}
}
</script>
<style>
.pub-chooseimage-wrap{
    width: 100%;
    margin: 0 auto 0.3rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.pub-chooseimage-wrap .pub-chooseimage-sect{
    width: 92%;
    margin: 0.2rem auto 0;
    background-color: #f8f4f4;
    border-radius: 0.14rem;
}
.pub-chooseimage-wrap .pub-chooseimage-sect .pub-chooseimage-item{
    width: 100%;
    min-height: 0.4rem;
    padding: 0.2rem 0;
    border-bottom: 1px solid #b5b6b6;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 0.32rem;
    color: #28a7e1;
    line-height: 0.44rem;
}
.pub-chooseimage-wrap .pub-chooseimage-sect .pub-chooseimage-item.panel-title{
    font-size: 0.26rem;
    color: #6a6f71;
}
.pub-chooseimage-wrap .pub-chooseimage-sect .pub-chooseimage-item:last-child{
    border: 0;
}
</style>


// WEBPACK FOOTER //
// src/shared/components/control/choose-image.vue